export const storageKeys = {
    abtests: {
        unleashGroups: 'unleashGroups',
        testSegment: 'testSegment',
        testSegment0: 'testSegment0',
        testSegment1: 'testSegment1',
        testSegment2: 'testSegment2',
        testSegment3: 'testSegment3',
        testSegment4: 'testSegment4',
        testSegment5: 'testSegment5',
        testSegment6: 'testSegment6',
        testSegment7: 'testSegment7',
        testSegment8: 'testSegment8',
        testSegment9: 'testSegment9',
        testSegment10: 'testSegment10',
        testSegment11: 'testSegment11',
        testSegment12: 'testSegment12',
        testSegment13: 'testSegment13',
        testSegment14: 'testSegment14'
    },
    auth: {
        accessToken: 'access_token',
        isLoggedIn: 'isLoggedIn'
    },
    cart: {
        cartToken: 'cart_token'
    },
    email: {
        freeMaterialDownloadUserEmail: 'freeMaterialDownloadUserEmail',
        emailRatingRedirect: 'email_rating_redirect',
        emailHash: 'emailHash',
        emailSHA256Hash: 'emailSHA256Hash'
    },
    favorites: {
        skipCatalogWishlistFolderModal: 'skipCatalogWishlistFolderModal',
        foldersAnnouncementShown: 'foldersAnnouncementShown'
    },
    general: {
        lastVisitedWorld: 'lastVisitedWorld',
        maintenanceWorkBanner: 'maintenanceWorkBanner',
        redirectLink: 'redirect_link',
        GAClientId: '_ga',
        GATrackId: '_gid',
        appBanner: 'appBanner',
        lastError: 'lastError',
        wasOnceRedirectedToProfileAfterLogin: 'wasOnceRedirectedToProfileAfterLogin',
        phraseEditor: 'phraseEditor',
        trackSid: 'track_sid',
        uiTest: 'uiTest',
        newFeatureTour: 'newFeatureTour',
        postponedQE: 'postponedQE',
        countryCode: 'countryCode',
        hideSchoolPopUp: 'hideSchoolPopUp'
    },
    interactive: {
        interactiveAnnouncementShown: 'interactiveAnnouncementShown',
        interactiveSearchOption: 'interactive-search-option'
    },
    material: {
        viewedMaterials: 'viewed_materials'
    },
    myUploads: {
        materialToBeEdit: 'toBeEdited',
        authorsCabinetLastSortOption: 'authorsCabinetLastSortOption'
    },
    payments: {
        lastPaymentMethod: 'lastPaymentMethod',
        isBuyNowFlow: 'isBuyNowFlow',
        lastOrderTracked: 'lastOrderTracked'
    },
    prices: {
        interactionWithPricePolicyModal: 'interactionWithPricePolicyModal',
        currencyCode: 'currencyCode'
    },
    search: {
        searchViewType: 'SRView',
        showAcquired: 'show-acquired'
    },
    user: {
        userId: 'userId',
        impersonated: 'impersonated',
        userSD: 'userSD',
        consentBannerInteraction: 'uc_user_interaction',
        isSeller: 'isSeller',
        oauthUserId: 'oauth_user_id',
        userSlug: 'userSlug',
        creationSource: 'creationSource',
        searchType: 'searchType',
        registeredFromSellerPage: 'registeredFromSellerPage'
    }
};
